import { fromPromise } from 'xstate';

import {
  type FavoritesMachineContext,
  type FavoriteWithId,
  type FetchFavoritesOutput,
  type ToggleFavoriteInput,
  type ToggleFavoriteOutput,
} from '../favorites-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createFavoritesMachineActors<Favorite extends FavoriteWithId>() {
  const fetchFavorites = fromPromise<
    FetchFavoritesOutput<Favorite>,
    FavoritesMachineContext<Favorite>
  >(async () => {
    throw new Error('`fetchFavorites` actor is not provided.');
  });

  const toggleFavorite = fromPromise<ToggleFavoriteOutput, ToggleFavoriteInput<Favorite>>(
    async () => {
      throw new Error('`toggleFavorite` actor is not provided.');
    },
  );

  return {
    fetchFavorites,
    toggleFavorite,
  };
}
